import React from 'react';
import { Topic } from '../types/index.ts';
import TopicRow from './TopicRow.tsx';

interface TopicTableProps {
  topics: Topic[];
  onTopicUpdate: () => void;
  sessionSettings?: { sessionDate: string; sessionTime: string } | null;
  showAISummary?: boolean;
  showDuration?: boolean;
  showEstimatedDate?: boolean;
  totalDuration?: number;
  autoOpenFeedbackTopicId?: string | null;
  onAutoOpenFeedbackCleared?: () => void;
}

const TopicTable: React.FC<TopicTableProps> = ({ topics, onTopicUpdate, sessionSettings, showAISummary = false, showDuration = false, showEstimatedDate = false, totalDuration = 0, autoOpenFeedbackTopicId = null, onAutoOpenFeedbackCleared }) => {
  if (topics.length === 0) {
    return (
      <div className="no-topics">
        <p>No topics submitted yet</p>
      </div>
    );
  }

  return (
    <div className="topic-table-container" style={{ overflow: 'visible' }}>
      <table className="topic-table" style={{ overflow: 'visible' }}>
        <thead>
          <tr>
            <th>Title</th>
            <th>Presenter(s)</th>
            {showEstimatedDate && <th>Estimated Presentation</th>}
            {showDuration && <th>Duration{totalDuration > 0 && <><br /><span style={{ fontWeight: 'normal', fontSize: '12px' }}>[{totalDuration} min]</span></>}</th>}
            <th>Attendees</th>
            <th>Confidence Impact</th>
            <th>Prep Hours Saved</th>
            <th>Customers Influenced</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody style={{ overflow: 'visible' }}>
          {topics.map((topic) => (
            <TopicRow
              key={topic.topicId}
              topic={topic}
              onTopicUpdate={onTopicUpdate}
              sessionSettings={sessionSettings}
              showAISummary={showAISummary}
              showDuration={showDuration}
              showEstimatedDate={showEstimatedDate}
              autoOpenFeedback={autoOpenFeedbackTopicId === topic.topicId}
              onAutoOpenFeedbackCleared={onAutoOpenFeedbackCleared}
            />
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default TopicTable;
